export default __webpack_public_path__ + "static/mobile_4-cb1c6524a6dec48e00d39e2f2074aac7.webp";